export function formatPct(n, digits = 1) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  return `${(Number(n) * 100).toFixed(digits)}%`;
}

export function formatNumber(n) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  return Number(n).toLocaleString();
}

export function formatSentiment(score) {
  if (score === null || score === undefined || Number.isNaN(Number(score))) return '—';
  const s = Number(score);
  const label = s > 0.15 ? 'Positive' : s < -0.15 ? 'Negative' : 'Neutral';
  return `${label} (${s.toFixed(2)})`;
}

export function relativeTime(iso) {
  if (!iso) return '—';
  try {
    const d = new Date(iso);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 60) return 'just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 86400 * 30) return `${Math.floor(diff / 86400)}d ago`;
    return d.toLocaleDateString();
  } catch (_e) {
    return '—';
  }
}

export function highlightBrand(text, brand) {
  if (!text || !brand) return text || '';
  const escaped = String(brand).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const re = new RegExp(`(${escaped})`, 'gi');
  const parts = text.split(re);
  return parts.map((p, i) => {
    if (p.toLowerCase() === String(brand).toLowerCase()) {
      return `<mark class="brand-highlight">${p}</mark>`;
    }
    return p;
  }).join('');
}
